import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Button,
  Container,
  Typography,
  Grid,
  Select,
  Box,
  Alert,
  CircularProgress,
  IconButton,
  Menu,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  CameraAlt,
  PhotoCamera,
  PhotoLibrary,
  Close,
  Cameraswitch,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth"; // Import your auth context

const AddBookmark = () => {
  const navigate = useNavigate();
  const { token, isAuthenticated } = useAuth(); // Get token from auth context

  const baseUrl = process.env.REACT_APP_BASE_URL;

  // State for all input fields
  const [ofirstName, setOfirstName] = useState("");
  const [omiddleName, setOmiddleName] = useState("");
  const [olastName, setOlastName] = useState("");
  const [ocontact, setOcontact] = useState("");
  const [odistrict, setOdistrict] = useState("");
  const [oemgContact, setOemgContact] = useState("");
  const [oaddress, setOaddress] = useState("");
  const [vbusinessName, setVbusinessName] = useState("");
  const [vreceiptNo, setVreceiptNo] = useState("");
  const [vvinNo, setVvinNo] = useState("");
  const [vengineNo, setVengineNo] = useState("");
  const [vkNo, setVkNo] = useState("");
  const [vlicensePlate, setVlicensePlate] = useState("");
  const [vvehicleID, setVvehicleID] = useState("");
  const [vcolor, setVcolor] = useState("");
  const [vAddress, setVAddress] = useState("");
  const [vsellerContact, setVsellerContact] = useState("");
  const [vmodel, setVmodel] = useState("");
  const [vpurchasedDate, setVpurchasedDate] = useState("");
  const [opfirstName, setOpfirstName] = useState("");
  const [opmiddleName, setOpmiddleName] = useState("");
  const [oplastName, setOplastName] = useState("");
  const [opContact, setOpContact] = useState("");
  const [opemgContact, setOpemgContact] = useState("");
  const [opdriverLicense, setOpdriverLicense] = useState("");
  const [opAddress, setOpAddress] = useState("");

  // States for profile images
  const [ownerProfileImage, setOwnerProfileImage] = useState(null);
  const [operatorProfileImage, setOperatorProfileImage] = useState(null);

  // States for file names
  const [ownerProfileImageName, setOwnerProfileImageName] = useState("");
  const [operatorProfileImageName, setOperatorProfileImageName] = useState("");

  // State for users dropdown
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  // Menu states for image upload options
  const [ownerMenuAnchor, setOwnerMenuAnchor] = useState(null);
  const [operatorMenuAnchor, setOperatorMenuAnchor] = useState(null);

  // Webcam modal states
  const [ownerWebcamOpen, setOwnerWebcamOpen] = useState(false);
  const [operatorWebcamOpen, setOperatorWebcamOpen] = useState(false);
  const [webcamStream, setWebcamStream] = useState(null);

  // Camera facing mode state - separate for each modal
  const [ownerFacingMode, setOwnerFacingMode] = useState('user');
  const [operatorFacingMode, setOperatorFacingMode] = useState('user');

  // Track if device supports multiple cameras
  const [hasMultipleCameras, setHasMultipleCameras] = useState(false);

  // Track if camera is currently switching
  const [isSwitchingCamera, setIsSwitchingCamera] = useState(false);

  // Refs for file inputs
  const ownerFileInputRef = useRef(null);
  const operatorFileInputRef = useRef(null);

  // Refs for webcam
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  // State for vehicles dropdown
  const [vehicle, setVehicle] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("");

  // Loading and error states
  const [loading, setLoading] = useState(false);
  const [usersLoading, setUsersLoading] = useState(true);
  const [error, setError] = useState("");
  const [usersError, setUsersError] = useState("");

  //Vehicle type
  const vehicleTypes = [
    { id: "1", name: "Motorcycle" },
    { id: "2", name: "Tricycle" },
  ];

  // Fetch users from the backend
  useEffect(() => {
    let isMounted = true;

    const fetchUsers = async () => {
      try {
        setUsersLoading(true);
        setUsersError("");

        // Check if user is authenticated
        if (!isAuthenticated || !token) {
          setUsersError("Please login to view users");
          setUsersLoading(false);
          return;
        }

        const response = await axios.get(`${baseUrl}/auth/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (isMounted) {
          setUsers(response.data);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching users", error);
          if (error.response?.status === 401) {
            setUsersError("Authentication failed. Please login again.");
          } else {
            setUsersError("Failed to load users. Please try again.");
          }
        }
      } finally {
        if (isMounted) {
          setUsersLoading(false);
        }
      }
    };

    fetchUsers();

    return () => {
      isMounted = false;
    };
  }, [baseUrl, token, isAuthenticated]);

  // Handle form submission
  const handleBookmark = async (e) => {
    e.preventDefault();

    // Check if user is authenticated
    if (!isAuthenticated || !token) {
      setError("Please login to add bookmarks");
      return;
    }

    // Basic form validation
    if (
      !selectedVehicle ||
      !ofirstName ||
      !olastName ||
      !vbusinessName ||
      !vlicensePlate ||
      !vvehicleID ||
      !opfirstName ||
      !oplastName ||
      !selectedUser
    ) {
      setError("Please fill in all required fields");
      return;
    }

    setLoading(true);
    setError("");

    const formData = new FormData();

    formData.append("vehicleType", selectedVehicle);
    formData.append("ofirstName", ofirstName);
    formData.append("omiddleName", omiddleName);
    formData.append("olastName", olastName);
    formData.append("ocontact", ocontact);
    formData.append("odistrict", odistrict);
    formData.append("oemgContact", oemgContact);
    formData.append("oaddress", oaddress);
    formData.append("vbusinessName", vbusinessName);
    formData.append("vreceiptNo", vreceiptNo);
    formData.append("vvinNo", vvinNo);
    formData.append("vengineNo", vengineNo);
    formData.append("vkNo", vkNo);
    formData.append("vlicensePlate", vlicensePlate);
    formData.append("vvehicleID", vvehicleID);
    formData.append("vcolor", vcolor);
    formData.append("vAddress", vAddress);
    formData.append("vsellerContact", vsellerContact);
    formData.append("vmodel", vmodel);
    formData.append("vpurchasedDate", vpurchasedDate);
    formData.append("opfirstName", opfirstName);
    formData.append("opmiddleName", opmiddleName);
    formData.append("oplastName", oplastName);
    formData.append("opContact", opContact);
    formData.append("opemgContact", opemgContact);
    formData.append("opdriverLicense", opdriverLicense);
    formData.append("opAddress", opAddress);
    formData.append("userId", selectedUser);

    if (ownerProfileImage)
      formData.append("ownerProfileImage", ownerProfileImage);
    if (operatorProfileImage)
      formData.append("operatorProfileImage", operatorProfileImage);

    try {
      await axios.post(`${baseUrl}/auth/addBookmark`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      alert("Bookmark Added Successfully!");
      navigate("/dashboard/bookmarks");
    } catch (error) {
      console.error("Error adding bookmark", error);
      if (error.response?.status === 401) {
        setError("Authentication failed. Please login again.");
      } else if (error.response?.data?.error) {
        setError(`Failed to add bookmark: ${error.response.data.error}`);
      } else {
        setError("Failed to add bookmark. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleOwnerImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type and size
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];
      const maxSize = 5 * 1024 * 1024; // 5MB

      if (!allowedTypes.includes(file.type)) {
        setError(
          "Only JPG, JPEG, PNG, and GIF files are allowed for profile images.",
        );
        e.target.value = "";
        return;
      }
      if (file.size > maxSize) {
        setError("Profile image size must be less than 5MB.");
        e.target.value = "";
        return;
      }

      setOwnerProfileImage(file);
      setOwnerProfileImageName(file.name);
      setError(""); // Clear any previous errors
    }
  };

  const handleOperatorImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type and size
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];
      const maxSize = 5 * 1024 * 1024; // 5MB

      if (!allowedTypes.includes(file.type)) {
        setError(
          "Only JPG, JPEG, PNG, and GIF files are allowed for profile images.",
        );
        e.target.value = "";
        return;
      }
      if (file.size > maxSize) {
        setError("Profile image size must be less than 5MB.");
        e.target.value = "";
        return;
      }

      setOperatorProfileImage(file);
      setOperatorProfileImageName(file.name);
      setError(""); // Clear any previous errors
    }
  };

  // Menu handlers
  const handleOwnerMenuOpen = (event) => {
    setOwnerMenuAnchor(event.currentTarget);
  };

  const handleOwnerMenuClose = () => {
    setOwnerMenuAnchor(null);
  };

  const handleOperatorMenuOpen = (event) => {
    setOperatorMenuAnchor(event.currentTarget);
  };

  const handleOperatorMenuClose = () => {
    setOperatorMenuAnchor(null);
  };

  const handleOwnerTakePhoto = () => {
    handleOwnerMenuClose();
    setOwnerWebcamOpen(true);
  };

  const handleOwnerBrowseFiles = () => {
    handleOwnerMenuClose();
    ownerFileInputRef.current?.click();
  };

  const handleOperatorTakePhoto = () => {
    handleOperatorMenuClose();
    setOperatorWebcamOpen(true);
  };

  const handleOperatorBrowseFiles = () => {
    handleOperatorMenuClose();
    operatorFileInputRef.current?.click();
  };

  // Detect if device has multiple cameras
  const detectCameras = async () => {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        setHasMultipleCameras(false);
        return;
      }

      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(device => device.kind === 'videoinput');

      setHasMultipleCameras(videoDevices.length >= 2);
    } catch (err) {
      console.error('Error detecting cameras:', err);
      setHasMultipleCameras(false);
    }
  };

  // Start webcam
  const startWebcam = async (facingMode = null) => {
    try {
      // Check if getUserMedia is supported
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error("Camera access is not supported in this browser");
      }

      // Determine which facing mode to use
      let cameraMode = facingMode;
      if (!cameraMode) {
        if (ownerWebcamOpen) {
          cameraMode = ownerFacingMode;
        } else if (operatorWebcamOpen) {
          cameraMode = operatorFacingMode;
        } else {
          cameraMode = 'user';
        }
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: cameraMode
        },
        audio: false,
      });

      setWebcamStream(stream);

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        // Ensure video plays
        try {
          await videoRef.current.play();
        } catch (playError) {
          console.error("Error playing video:", playError);
        }
      }
    } catch (err) {
      console.error("Error accessing webcam:", err);
      let errorMessage = "Unable to access webcam. ";

      if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
        errorMessage += "Camera permission was denied. Please allow camera access in your browser settings.";
      } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
        errorMessage += "No camera was found on your device.";
      } else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
        errorMessage += "Camera is already in use by another application.";
      } else if (err.name === 'OverconstrainedError') {
        errorMessage += "Camera doesn't support the requested settings.";
        // Fallback to front camera if back camera not supported
        if (facingMode === 'environment') {
          console.log("Falling back to front camera");
          return startWebcam('user');
        }
      } else if (err.name === 'SecurityError') {
        errorMessage += "Camera access is blocked. Make sure you're using HTTPS or localhost.";
      } else {
        errorMessage += err.message || "Please check your camera permissions and try again.";
      }

      setError(errorMessage);

      // Close modals if webcam fails
      setOwnerWebcamOpen(false);
      setOperatorWebcamOpen(false);
      setIsSwitchingCamera(false);
    }
  };

  // Stop webcam
  const stopWebcam = () => {
    if (webcamStream) {
      webcamStream.getTracks().forEach((track) => track.stop());
      setWebcamStream(null);
    }
  };

  // Handle owner camera flip
  const handleOwnerCameraFlip = async () => {
    if (isSwitchingCamera) return;

    setIsSwitchingCamera(true);

    try {
      stopWebcam();
      const newMode = ownerFacingMode === 'user' ? 'environment' : 'user';
      setOwnerFacingMode(newMode);

      await new Promise(resolve => setTimeout(resolve, 100));
      await startWebcam(newMode);
    } catch (err) {
      console.error('Error flipping camera:', err);
      setError('Failed to switch camera. Please try again.');
    } finally {
      setIsSwitchingCamera(false);
    }
  };

  // Handle operator camera flip
  const handleOperatorCameraFlip = async () => {
    if (isSwitchingCamera) return;

    setIsSwitchingCamera(true);

    try {
      stopWebcam();
      const newMode = operatorFacingMode === 'user' ? 'environment' : 'user';
      setOperatorFacingMode(newMode);

      await new Promise(resolve => setTimeout(resolve, 100));
      await startWebcam(newMode);
    } catch (err) {
      console.error('Error flipping camera:', err);
      setError('Failed to switch camera. Please try again.');
    } finally {
      setIsSwitchingCamera(false);
    }
  };

  // Close webcam modals
  const handleOwnerWebcamClose = () => {
    stopWebcam();
    setOwnerWebcamOpen(false);
  };

  const handleOperatorWebcamClose = () => {
    stopWebcam();
    setOperatorWebcamOpen(false);
  };

  // Capture photo from webcam
  const captureOwnerPhoto = () => {
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0);

      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], `owner-photo-${Date.now()}.jpg`, {
            type: "image/jpeg",
          });
          setOwnerProfileImage(file);
          setOwnerProfileImageName(file.name);
          handleOwnerWebcamClose();
        }
      }, "image/jpeg", 0.95);
    }
  };

  const captureOperatorPhoto = () => {
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0);

      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], `operator-photo-${Date.now()}.jpg`, {
            type: "image/jpeg",
          });
          setOperatorProfileImage(file);
          setOperatorProfileImageName(file.name);
          handleOperatorWebcamClose();
        }
      }, "image/jpeg", 0.95);
    }
  };

  // Effect to start webcam when modal opens
  useEffect(() => {
    if (ownerWebcamOpen || operatorWebcamOpen) {
      // Delay webcam start to ensure dialog is fully rendered
      const timer = setTimeout(async () => {
        await detectCameras();
        startWebcam();
      }, 300);
      return () => {
        clearTimeout(timer);
        stopWebcam();
      };
    } else {
      stopWebcam();
    }
  }, [ownerWebcamOpen, operatorWebcamOpen]);

  if (!isAuthenticated) {
    return (
      <Container maxWidth="xl" sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ mt: 3, mb: 3 }}
          gutterBottom
        >
          Add Bookmark
        </Typography>
        <Alert severity="error" sx={{ mb: 2 }}>
          Please login to add bookmarks.
        </Alert>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/login")}
        >
          Go to Login
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ mb: 3 }}>
      <Typography
        variant="h4"
        component="h1"
        sx={{ mt: 3, mb: 3 }}
        gutterBottom
      >
        Add Bookmark
      </Typography>

      {/* Error Alert */}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <form onSubmit={handleBookmark}>
        {/* Vehicle Type */}
        <Box
          sx={{
            mb: 3,
            p: 2,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          <Typography variant="h6">Vehicle Type</Typography>
          <Box sx={{ mb: 3 }}>
            <FormControl fullWidth>
              <InputLabel id="vehicle-type-label">
                Select vehicle type
              </InputLabel>
              <Select
                labelId="vehicle-type-label"
                value={selectedVehicle}
                onChange={(e) => setSelectedVehicle(e.target.value)}
                label="Select vehicle type"
                required
              >
                {vehicleTypes.map((vehicle) => (
                  <MenuItem key={vehicle.id} value={vehicle.id}>
                    {vehicle.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>

        {/* Owner's Information */}
        <Box
          sx={{
            mb: 3,
            p: 2,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          <Typography variant="h6">Owner's Information</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Owner First Name"
                variant="outlined"
                value={ofirstName}
                onChange={(e) => setOfirstName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Owner Middle Name"
                variant="outlined"
                value={omiddleName}
                onChange={(e) => setOmiddleName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Owner Last Name"
                variant="outlined"
                value={olastName}
                onChange={(e) => setOlastName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Owner Contact"
                variant="outlined"
                value={ocontact}
                onChange={(e) => setOcontact(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Owner District"
                variant="outlined"
                value={odistrict}
                onChange={(e) => setOdistrict(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Owner Emergency Contact"
                variant="outlined"
                value={oemgContact}
                onChange={(e) => setOemgContact(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Owner Address"
                variant="outlined"
                value={oaddress}
                onChange={(e) => setOaddress(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                <IconButton
                  color="primary"
                  onClick={handleOwnerMenuOpen}
                  sx={{
                    border: '2px solid',
                    borderColor: 'primary.main',
                    '&:hover': { backgroundColor: 'primary.light', color: 'white' }
                  }}
                >
                  <CameraAlt />
                </IconButton>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    Owner Profile Image
                  </Typography>
                  {ownerProfileImageName && (
                    <Typography variant="caption" color="primary" sx={{ display: 'block', mt: 0.5 }}>
                      {ownerProfileImageName}
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Hidden file input for browsing */}
              <input
                ref={ownerFileInputRef}
                type="file"
                accept="image/*"
                onChange={handleOwnerImageChange}
                style={{ display: 'none' }}
              />

              {/* Menu for owner image upload */}
              <Menu
                anchorEl={ownerMenuAnchor}
                open={Boolean(ownerMenuAnchor)}
                onClose={handleOwnerMenuClose}
              >
                <MenuItem onClick={handleOwnerTakePhoto}>
                  <ListItemIcon>
                    <PhotoCamera fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Take Photo</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleOwnerBrowseFiles}>
                  <ListItemIcon>
                    <PhotoLibrary fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Browse Files</ListItemText>
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Box>

        {/* Vehicle Information */}
        <Box
          sx={{
            mb: 3,
            p: 2,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          <Typography variant="h6">Vehicle Information</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Business Name"
                variant="outlined"
                value={vbusinessName}
                onChange={(e) => setVbusinessName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Receipt Number"
                variant="outlined"
                value={vreceiptNo}
                onChange={(e) => setVreceiptNo(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="VIN Number"
                variant="outlined"
                value={vvinNo}
                onChange={(e) => setVvinNo(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Engine Number"
                variant="outlined"
                value={vengineNo}
                onChange={(e) => setVengineNo(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="K Number"
                variant="outlined"
                value={vkNo}
                onChange={(e) => setVkNo(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="License Plate"
                variant="outlined"
                value={vlicensePlate}
                onChange={(e) => setVlicensePlate(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Vehicle ID"
                variant="outlined"
                value={vvehicleID}
                onChange={(e) => setVvehicleID(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Color"
                variant="outlined"
                value={vcolor}
                onChange={(e) => setVcolor(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Address"
                variant="outlined"
                value={vAddress}
                onChange={(e) => setVAddress(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Seller Contact"
                variant="outlined"
                value={vsellerContact}
                onChange={(e) => setVsellerContact(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Model"
                variant="outlined"
                value={vmodel}
                onChange={(e) => setVmodel(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Purchased Date"
                variant="outlined"
                type="date"
                value={vpurchasedDate}
                onChange={(e) => setVpurchasedDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Operator's Information */}
        <Box
          sx={{
            mb: 3,
            p: 2,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          <Typography variant="h6">Operator's Information</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Operator First Name"
                variant="outlined"
                value={opfirstName}
                onChange={(e) => setOpfirstName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Operator Middle Name"
                variant="outlined"
                value={opmiddleName}
                onChange={(e) => setOpmiddleName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                margin="normal"
                label="Operator Last Name"
                variant="outlined"
                value={oplastName}
                onChange={(e) => setOplastName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Operator Contact"
                variant="outlined"
                value={opContact}
                onChange={(e) => setOpContact(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Operator Emergency Contact"
                variant="outlined"
                value={opemgContact}
                onChange={(e) => setOpemgContact(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Operator Driver License"
                variant="outlined"
                value={opdriverLicense}
                onChange={(e) => setOpdriverLicense(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Operator Address"
                variant="outlined"
                value={opAddress}
                onChange={(e) => setOpAddress(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                <IconButton
                  color="primary"
                  onClick={handleOperatorMenuOpen}
                  sx={{
                    border: '2px solid',
                    borderColor: 'primary.main',
                    '&:hover': { backgroundColor: 'primary.light', color: 'white' }
                  }}
                >
                  <CameraAlt />
                </IconButton>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    Operator Profile Image
                  </Typography>
                  {operatorProfileImageName && (
                    <Typography variant="caption" color="primary" sx={{ display: 'block', mt: 0.5 }}>
                      {operatorProfileImageName}
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Hidden file input for browsing */}
              <input
                ref={operatorFileInputRef}
                type="file"
                accept="image/*"
                onChange={handleOperatorImageChange}
                style={{ display: 'none' }}
              />

              {/* Menu for operator image upload */}
              <Menu
                anchorEl={operatorMenuAnchor}
                open={Boolean(operatorMenuAnchor)}
                onClose={handleOperatorMenuClose}
              >
                <MenuItem onClick={handleOperatorTakePhoto}>
                  <ListItemIcon>
                    <PhotoCamera fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Take Photo</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleOperatorBrowseFiles}>
                  <ListItemIcon>
                    <PhotoLibrary fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Browse Files</ListItemText>
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Box>

        {/* Operator Selection */}
        <Box sx={{ mb: 3 }}>
          <FormControl fullWidth>
            <InputLabel id="user-select-label">Select Operator</InputLabel>
            <Select
              labelId="user-select-label"
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
              label="Select Operator"
              required
            >
              {usersLoading ? (
                <MenuItem disabled>
                  <Box display="flex" alignItems="center">
                    <CircularProgress size={20} sx={{ mr: 2 }} />
                    Loading users...
                  </Box>
                </MenuItem>
              ) : usersError ? (
                <MenuItem disabled>{usersError}</MenuItem>
              ) : (
                users.map((user) => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.username}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
          {usersError && !usersLoading && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {usersError}
            </Alert>
          )}
        </Box>

        {/* Submit Button */}
        <Box item xs={12} sx={{ mt: 3 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? (
              <Box display="flex" alignItems="center">
                <CircularProgress size={20} sx={{ mr: 2 }} />
                Adding Bookmark...
              </Box>
            ) : (
              "Add Bookmark"
            )}
          </Button>
        </Box>
      </form>

      {/* Owner Webcam Modal */}
      <Dialog
        open={ownerWebcamOpen}
        onClose={handleOwnerWebcamClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Take Owner Photo</Typography>
            <IconButton onClick={handleOwnerWebcamClose} size="small">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ position: 'relative', width: '100%', bgcolor: 'black', borderRadius: 2, overflow: 'hidden', minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {!webcamStream && (
              <CircularProgress sx={{ color: 'white' }} />
            )}
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              style={{ width: '100%', display: webcamStream ? 'block' : 'none' }}
            />

            {/* Camera Flip Button */}
            {webcamStream && hasMultipleCameras && (
              <IconButton
                onClick={handleOwnerCameraFlip}
                disabled={isSwitchingCamera}
                sx={{
                  position: 'absolute',
                  top: 16,
                  right: 16,
                  bgcolor: 'rgba(255, 255, 255, 0.9)',
                  color: 'primary.main',
                  '&:hover': {
                    bgcolor: 'white',
                  },
                  '&:disabled': {
                    bgcolor: 'rgba(255, 255, 255, 0.5)',
                  },
                  boxShadow: 3,
                  zIndex: 1,
                }}
              >
                <Cameraswitch />
              </IconButton>
            )}
          </Box>
          <canvas ref={canvasRef} style={{ display: 'none' }} />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleOwnerWebcamClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={captureOwnerPhoto}
            variant="contained"
            startIcon={<PhotoCamera />}
            disabled={!webcamStream}
          >
            Capture Photo
          </Button>
        </DialogActions>
      </Dialog>

      {/* Operator Webcam Modal */}
      <Dialog
        open={operatorWebcamOpen}
        onClose={handleOperatorWebcamClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Take Operator Photo</Typography>
            <IconButton onClick={handleOperatorWebcamClose} size="small">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ position: 'relative', width: '100%', bgcolor: 'black', borderRadius: 2, overflow: 'hidden', minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {!webcamStream && (
              <CircularProgress sx={{ color: 'white' }} />
            )}
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              style={{ width: '100%', display: webcamStream ? 'block' : 'none' }}
            />

            {/* Camera Flip Button */}
            {webcamStream && hasMultipleCameras && (
              <IconButton
                onClick={handleOperatorCameraFlip}
                disabled={isSwitchingCamera}
                sx={{
                  position: 'absolute',
                  top: 16,
                  right: 16,
                  bgcolor: 'rgba(255, 255, 255, 0.9)',
                  color: 'primary.main',
                  '&:hover': {
                    bgcolor: 'white',
                  },
                  '&:disabled': {
                    bgcolor: 'rgba(255, 255, 255, 0.5)',
                  },
                  boxShadow: 3,
                  zIndex: 1,
                }}
              >
                <Cameraswitch />
              </IconButton>
            )}
          </Box>
          <canvas ref={canvasRef} style={{ display: 'none' }} />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleOperatorWebcamClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={captureOperatorPhoto}
            variant="contained"
            startIcon={<PhotoCamera />}
            disabled={!webcamStream}
          >
            Capture Photo
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AddBookmark;
